export default __webpack_public_path__ + "static/media/text-size.3058fef1.svg";